import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { AddCard, Api, AddAlert, AppRegistration, Assessment, Bloodtype, InstallMobile, CallSplit, DirectionsTransit, DataSaverOn, Dialpad, GradeOutlined, VerifiedUserRounded, StickyNote2Rounded, FlightClassOutlined, Games, Subject } from "@mui/icons-material";
import './dashboard.css'
import { Grid } from '@mui/material';
import { useNavigate } from 'react-router';
import { User_Data } from "../../../../hooks/Requests/localStroagedata";

export default function FarsiNavigationButons() {
    const navigate = useNavigate();
    const handleClick = (loc) => {
        navigate('/Private/'+loc)
      };
       let getRoles = User_Data == undefined ? undefined : User_Data.roles[0]  == undefined ? 'empty' : User_Data.roles[0];
  return (
    // <Box
    //   sx={{
    //     display: 'inline-flex', // Display as inline-block for button-like behavior
    //     alignItems: 'center',
    //     justifyContent: 'center',
    //     padding: '100px 100px', // Padding to make the button larger
    //     fontSize: '15px',
    //     fontWeight: 'bold',
    //     backgroundColor: '#ffcd47', // Tomato color background
    //     border: '0px solid #000', // Border to mimic button outline (optional)
    //     borderRadius: '4px',
    //     cursor: 'pointer',
    //     transition: 'transform 0.3s ease, box-shadow 0.3s ease', // Button hover animation
    //     position: 'relative', // Ensure the icon can be positioned independently
    //     flexDirection: 'column', // Make the content stack vertically
    //     "&:hover": {
    //       transform: 'scale(1.1)', // Scale up the div on hover
    //       boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)', // Add shadow effect on hover
    //     },
    //     "&:hover .MuiSvgIcon-root": {
    //       transform: 'rotateY(180deg)', // Flip the icon on hover
    //     },
    //   }}
    // >
    //   <AddCard sx={{ fontSize: '80px', color: 'white', transition: 'transform 0.6s ease' }} />

    //   <span style={{ marginTop: '10px', color: 'white' }}>This is a larger MUI div</span>
    // </Box>


    <Grid container spacing={1}> {/* Make the outer Grid a container */}
        {getRoles.StudentReport?
        <Grid item xs={12} sm={6} lg={4}> {/* Make each inner Grid an item */}
        <Box className="animated-button studentRep" onClick={()=>handleClick('Report/Student')}>
        <span className='opa'>ناسوب</span>
            <Assessment sx={{ fontSize: '4rem', color: 'white', transition: 'transform 0.6s ease' }} />
            <span className='pashtoName'> گزارش شاگرد</span>
        </Box>
    `   </Grid>: null}

        {getRoles.StudentAttendance?
      <Grid item xs={12} sm={6} lg={4}>
        <Box className="animated-button attendance" onClick={()=>handleClick('Attendance/Student')}>
        <span className='opa'>kds</span>
          <FlightClassOutlined sx={{ fontSize: '4rem', color: 'white', transition: 'transform 0.6s ease' }} />
          <span className='pashtoName'> حاضری شاگرد</span>
        </Box>
      </Grid>: null}

        {getRoles.StudentReg?
      <Grid item xs={12} sm={6} lg={4}>
        <Box className="animated-button studentReg" onClick={()=>handleClick('Registration/Student')}>
        <span className='opa'>1V62</span>
          <AppRegistration sx={{ fontSize: '4rem', color: 'white', transition: 'transform 0.6s ease' }} />
          <span className='pashtoName'>ثبت‌نام شاگرد</span>
        </Box>
      </Grid>: null}
      
        {/* {getRoles.StudentActive?
      <Grid item xs={12} sm={6} lg={4}>
        <Box className="animated-button card" onClick={()=>handleClick('Veiw/Students')}>
        <span className='opa'>کندهار</span>
          <AddCard sx={{ fontSize: '4rem', color: 'white', transition: 'transform 0.6s ease' }} />
          <span className='pashtoName'>کارت زبان آموز</span>
        </Box>
      </Grid>: null} */}
      
        {getRoles.MobileApp?
      <Grid item xs={12} sm={6} lg={4}>
        <Box className="animated-button mobile" onClick={()=>handleClick('Veiw/Mobile')}>
          <span className='opa'>dom</span>
          <InstallMobile sx={{ fontSize: '4rem', color: 'white', transition: 'transform 0.6s ease' }} />
          <span className='pashtoName'>موبایل اپلیکیشن</span>
        </Box>
      </Grid>: null}
      
        {getRoles.Result?
      <Grid item xs={12} sm={6} lg={4}>
        <Box className="animated-button report" onClick={()=>handleClick('StudentResult')}>
        <span className='opa'>MDL</span>
          <StickyNote2Rounded sx={{ fontSize: '4rem', color: 'white', transition: 'transform 0.6s ease' }} />
          <span className='pashtoName'>اطلاعنامه</span>
        </Box>
      </Grid>: null}
      
        {getRoles.Transport?
      <Grid item xs={12} sm={6} lg={4}>
        <Box className="animated-button transport" onClick={()=>handleClick('Transport')}>
        <span className='opa'>Sofi</span>
          <DirectionsTransit sx={{ fontSize: '4rem', color: 'white', transition: 'transform 0.6s ease' }} />
          <span className='pashtoName'>ترانسپورت</span>
        </Box>
      </Grid>: null}
      
        {getRoles.Admin?
      <Grid item xs={12} sm={6} lg={4}>
        <Box className="animated-button authority" onClick={()=>handleClick('Auth/Role')}>
        <span className='opa'>235D</span>
          <Api sx={{ fontSize: '4rem', color: 'white', transition: 'transform 0.6s ease' }} />
          <span className='pashtoName'> مقامات   </span>
        </Box>
      </Grid>: null}
      
        {getRoles.Income?
      <Grid item xs={12} sm={6} lg={4}>
        <Box className="animated-button income" onClick={()=>handleClick('Expense/Income')}>
        <span className='opa'>K0SD</span>
          <DataSaverOn sx={{ fontSize: '4rem', color: 'white', transition: 'transform 0.6s ease' }} />
          <span className='pashtoName'> عاید</span>
        </Box>
      </Grid>: null}
      
    </Grid>
  );
}